// Copyright (c) 2019 Deere & Company

import React, {PropTypes} from 'react';

import ClaimOtherCredit from '@deere/cps-it.warranty-model-factory/lib/claim-item-other-credit';
import ClaimVsrMessage from '@deere/cps-it.warranty-model-factory/lib/claim-vsr-message';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import OtherCreditsPanel from '../../../shared/components/other-credits-panel';

function handleCreditAmountChange(index, amount) {

    this.actions.changeAmount(index, amount);

}

function handleCreditCommentsChange(index, comments) {

    this.actions.changeComments(index, comments);

}

function handleCreditCreate() {

    this.actions.createOtherCredit();

}

function handleCreditDeletion(index) {

    this.actions.deleteOtherCredit(index);

}

function handleCreditDescriptionChange(index, description, descriptionCollection) {

    this.actions.changeDescription(index, description, descriptionCollection);

}

function handleCreditDistanceChange(index, distance) {

    this.actions.changeDistance(index, distance);

}

const OtherCreditsPanelContainer = props =>
    <OtherCreditsPanel
        errors={props.errors}
        isEditable={props.isEditable}
        onAmountChange={props::handleCreditAmountChange}
        onCommentsChange={props::handleCreditCommentsChange}
        onCreate={props::handleCreditCreate}
        onDelete={props::handleCreditDeletion}
        onDescriptionChange={props::handleCreditDescriptionChange}
        onDistanceChange={props::handleCreditDistanceChange}
        otherCreditDescriptions={props.otherCreditDescriptions}
        otherCredits={props.otherCredits}
    />;

OtherCreditsPanelContainer.displayName = 'OtherCreditsPanelContainer';
OtherCreditsPanelContainer.propTypes = {
    actions: PropTypes.object.isRequired,
    errors: PropTypes.arrayOf(PropTypes.instanceOf(ClaimVsrMessage)),
    isEditable: PropTypes.bool.isRequired,
    otherCreditDescriptions: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    otherCredits: PropTypes.arrayOf(PropTypes.instanceOf(ClaimOtherCredit)).isRequired
};

export default OtherCreditsPanelContainer;



// WEBPACK FOOTER //
// ./src/claim/incentive/components/other-credits-panel/other-credits-panel-container.js